import { Skeleton, Stack } from '@mantine/core';

export default () => (
  <section
    className={`flex flex-auto flex-col overflow-hidden relative rounded-[20px] bg-white border border-[#F8F6FF]`}
  >
    <Stack align={'center'} my={50}>
      <Skeleton height={20} width={'90%'} mt={6} radius="md" />
      <Skeleton height={20} width={'90%'} mt={6} radius="md" />
      <Skeleton height={20} width={'90%'} mt={6} radius="md" />
    </Stack>
  </section>
);
